import { defineStore } from "pinia";

export const useMobileSajuLnbStore = defineStore('mobileSajuLnb', () => {
  /** 앱에서 전달받은 guestUserId */
  const guestUserId = ref(null);

  /** 앱에서 전달받은 guestUerId 업데이트 함수 */
  const setGuestUserId = (id) => {
    guestUserId.value = id;
  };

  /** 앱에서 전달받은 userName */
  const userName = ref('');

  /** 앱에서 전달받은 userName 업데이트 */
  const setUserName = (name) => {
    userName.value = name;
  }

  /** 앱에서 전달받은 모드 (primary: 대표사주, normal: 일반 상세분석, null: 미확정) */
  const mode = ref(null);
  const setMode = (m) => {
    mode.value = m;
  };

  // 앱에서 전달받은 inset
  const bottomInset = ref(0);
  const setBottomInset = (inset) => {
    bottomInset.value = inset;
  };

  // SajuInsightLnb에서 보여지는 사주 정보
  const paramData = ref(null);
  const setParamData = (data) => {
    paramData.value = data;
  };

  /** 분석권 구매 시, 앱 사주목록 새로고침 필요 여부 */
  const needRefresh = ref(false);
  const setNeedRefresh = (state) => {
    needRefresh.value = state;
  };

  /** analysisMobile 데이터 초기화 */
  const resetMobileSajuStore = () => {
    setGuestUserId(null);
    setUserName('');
    setMode(null);
    setBottomInset(0);
    setParamData(null);
  };

  return {
    guestUserId,
    setGuestUserId,

    userName,
    setUserName,

    mode,
    setMode,

    bottomInset,
    setBottomInset,

    paramData,
    setParamData,

    needRefresh,
    setNeedRefresh,
    
    resetMobileSajuStore,
  };
});